import { useState, useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

export const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    const initGoogleMaps = async () => {
      try {
        // const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        // if (!apiKey) {
        //   throw new Error('Google Maps API key is missing');
        // }

        const loader = new Loader({
          apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
          // Use a supported channel. "weekly" is default; "quarterly" is more stable.
          version: 'weekly',
          // Only include actual libraries; "maps" is not a library name here.
          libraries: ['places', 'marker']
        });

        // Explicitly load both Maps and Places
        await loader.importLibrary('maps');
        await loader.importLibrary('places');
        await loader.importLibrary('marker');
        

        // Additional verification
        if (!window.google || !window.google.maps || !window.google.maps.places) {
          throw new Error('Google Maps libraries not fully initialized');
        }

        setIsLoaded(true);
      } catch (error) {
        setLoadError(error);
      }
    };

    initGoogleMaps();
  }, []);

  return { isLoaded, loadError };
};